import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Select } from '@ngxs/store';
import { UserState } from '../../../core/store/user/user.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '../../../core/models/user.model';
import { PortalService } from '../../../core/services/portal.service';
import { Portal } from '../../../core/models/portal.model';

@Component({
  selector: 'brn-menu-user',
  templateUrl: './menu-user.component.html',
  styleUrls: ['./menu-user.component.scss'],
})
export class MenuUserComponent implements OnInit, OnDestroy {
  @Select(UserState.me) user$!: Observable<User>;
  user?: User;
  portalSettings: Portal;

  private unsubscribe$: Subject<any> = new Subject();

  constructor(public location: Location) {
    this.portalSettings = PortalService.Settings;
  }

  ngOnInit(): void {
    this.user$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      this.user = user;
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
